import React from 'react';
import { useParams } from 'react-router-dom';
import ConferencePage from './ConferencePage';
import { getConference } from '../../data/conferences';

/**
 * Résout l'identifiant de conférence de l'URL (`/conference/:conferenceId`)
 * et monte la présentation correspondante.
 *
 * La `key` force un remontage complet au changement de conférence :
 * l'état du diaporama (slide courante, animations, audio) repart de zéro.
 */
const ConferenceRoute = () => {
    const { conferenceId } = useParams();
    const conference = getConference(conferenceId);

    return (
        <ConferencePage
            key={conference.id}
            slides={conference.slides}
            conferenceId={conference.id}
            conducteur={conference.conducteur}
            logo={conference.logo}
        />
    );
};

export default ConferenceRoute;
